
import React from "react"

export default class OTPTimer extends React.Component {

    state = {
       timer: 15,
       intervalCode: null
    }
 
    componentDidMount() {
       const intervalCode = setInterval(() => this.setState({ timer: this.state.timer <= 0 ? clearInterval(this.state.intervalCode) : this.state.timer - 1 }), 1000)
       this.setState({ intervalCode })
    }
 
    componentWillUnmount() {
       clearInterval(this.state.intervalCode)
    }
 
 
    handleStartTimer = () => {
       const intervalCode = setInterval(() => this.setState({ timer: this.state.timer <= 0 ? clearInterval(this.state.intervalCode) : this.state.timer - 1 }), 1000)
       this.setState({ intervalCode, timer: 15 })
    }
 
 
    render() {
       return (
          <div>
             {this.state.timer ? <div>Please wait <span className="red">{this.state.timer} sec..</span></div> : this.props.handleTimerEnd()}
          </div>
       )
    }
 }
 